//
// Mobile Navbar
// --------------------------------------------------

$('.navbar-toggle').on('click', function() {
	
	if ($( '.navbar-collapse' ).hasClass('in')) {
		$( '#navbar-mobile-state' ).removeClass( 'fa-times' );
		$( '#navbar-mobile-state' ).addClass( 'fa-bars' );

        $( '#navbar-layer' ).removeClass( 'navbar-open' );
        $( '.page-header' ).removeClass( 'navbar-open' );
	} else {
		$( '#navbar-mobile-state' ).removeClass( 'fa-bars' );
		$( '#navbar-mobile-state' ).addClass( 'fa-times' );

        $( '#navbar-layer' ).addClass( 'navbar-open' );
        $( '.page-header' ).addClass( 'navbar-open' );
	}

});


// WEBPACK FOOTER //
// ./Private/JavaScript/Component/MobileMenu.js